/* eslint-disable */
import { find } from 'lodash';
import { mapActions } from 'vuex';
import env from '@/env';
import { withMeta } from '@/helpers/dataLayer';
import log from '@/logger';

const externalLinksMixin = {
  data() {
    return {
      links: null,
    };
  },
  methods: {
    ...mapActions('user', ['getExternalLogins']),
    registrationTrack(label) {
      this.$gtm.trackEvent(
        withMeta({
          event: 'eventTrackerTrigger',
          category: 'Registration',
          action: 'submit',
          label,
        }),
      );
    },
    twitterLinkClick() {
      this.registrationTrack('Twitter');
      log.info('TWITTER LINK CLICKED', this.twitterLink);
      window.location.href = this.twitterLink;
    },
    facebookLinkClick() {
      this.registrationTrack('Facebook');
      log.info('FACEBOOK LINK CLICKED', this.facebookLink);
      window.location.href = this.facebookLink;
    },
    googleLinkClick() {
      this.registrationTrack('Google');
      log.info('GOOGLE LINK CLICKED', this.googleLink);
      window.location.href = this.googleLink;
    },
  },
  computed: {
    twitterLink() {
      const data = find(this.links, (l) => l.name === 'Twitter');
      return data ? `${env.SOCIAL_AUTH_URL}${data.url}` : null;
    },
    facebookLink() {
      const data = find(this.links, (l) => l.name === 'Facebook');
      return data ? `${env.SOCIAL_AUTH_URL}${data.url}` : null;
    },
    googleLink() {
      const data = find(this.links, (l) => l.name === 'Google');
      return data ? `${env.SOCIAL_AUTH_URL}${data.url}` : null;
    },
  },
};

export default externalLinksMixin;
